export * from './lib/details-table.module';

export * from './lib/details-table.component';
